<template>
  <div>
    <el-popover placement="top" trigger="click">
      <chrome-picker
        :value="colors"
        @input="updateFromPicker"
        v-if="displayPicker"
        disableAlpha
      />
      <div slot="reference" class="el-color-picker__trigger">
        <span class="el-color-picker__color"
          ><span
            class="el-color-picker__color-inner"
            :style="{ backgroundColor: colorValue }"
          ></span>
        </span>
        <span class="el-color-picker__icon el-icon-arrow-down"></span>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { Chrome } from "vue-color";
export default {
  name: "ColorPanel",
  components: {
    "chrome-picker": Chrome,
  },
  props: ["color"],
  data() {
    return {
      colors: {
        hex: "#ffffff",
      },
      colorValue: "",
      displayPicker: true,
    };
  },
  mounted() {
    if (this.color) {
      this.setColor(this.color );
    }
  },
  methods: {
    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      if (color.slice(0, 1) == "#") {
        this.colors = {
          hex: color,
        };
      } else if (color.slice(0, 4) == "rgba") {
        var rgba = color.replace(/^rgba?\(|\s+|\)$/g, "").split(","),
          hex =
            "#" +
            (
              (1 << 24) +
              (parseInt(rgba[0]) << 16) +
              (parseInt(rgba[1]) << 8) +
              parseInt(rgba[2])
            )
              .toString(16)
              .slice(1);
        this.colors = {
          hex: hex,
          a: rgba[3],
        };
      }
    },
    showPicker() {
      document.addEventListener("click", this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      document.removeEventListener("click", this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      this.displayPicker ? this.hidePicker() : this.showPicker();
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      if (color.rgba.a == 1) {
        this.colorValue = color.hex;
      } else {
        this.colorValue =
          "rgba(" +
          color.rgba.r +
          ", " +
          color.rgba.g +
          ", " +
          color.rgba.b +
          ", " +
          color.rgba.a +
          ")";
      }
    },
    documentClick(e) {
      var el = this.$refs.colorpicker,
        target = e.target;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
  },
  watch: {
    color(val) {
      this.setColor(val);
    },
    colorValue(val) {
      if (val) {
        this.updateColors(val);
        this.$emit("input", val);
        //document.body.style.background = val;
      }
    },
  },
};
</script>
